// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"7ff00c8e","362":"6fed8e0f","453":"04f7d10b","766":"db452a22","960":"e89bac82"}[chunkId] + ".chunk.js";
};